import { render } from "./CustomerDetailHistoryTab.vue?vue&type=template&id=0f923bb4"
import script from "./CustomerDetailHistoryTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailHistoryTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__